export enum AlarmTypeEnum {
  DiskError = 1,
  InsufficientDiskSpace = 2,
  FaceRecognitionAlarm = 3,
  PersonnelFallAlarm = 4,
  SosAlarm = 5,
  VideoLost = 4096,
  MotionDetection = 4097,
  VideoBlocking = 4098,
  AlarmInput = 4099,
  CycleAlarm = 4100,
  LowTemperatureAlarm = 4103,
  HighTemperatureAlarm = 4104,
  LowSpeedAlarm = 4105,
  OverspeedAlarm = 4106,
  EnteringAreaAlarm = 4107,
  LeavingZoneAlarm = 4108,
  LowVoltageAlarm = 4109,
  HighVoltageAlarm = 4110,
  EquipmentInactivityAlarm = 4111,
  EquipmentInversionAlarm = 4112,
  DeviceBatteryRemoved = 4113,
  DeviceRemoved = 4114,
  LowDeviceBattery = 4115,
  LineEntryAlarm = 4116,
  OffLineAlarm = 4117,
  HatTakenOffAlarm = 4118,
  HatImpactAlarm = 4119,
  NearPowerAlarm = 4120,
  HighAltitudeAlarm = 4121,
}

export enum AlarmStatusEnum {
  Alarm = 0,
  AutomaticRelease = 1,
  ManualRelease = 2,
  ManualIgnore = 3,
}

export interface AlarmRecordDto {
  key: string;
  type?: AlarmTypeEnum;
  status?: AlarmStatusEnum;
  timestamp?: number;
  device_id?: string;
  lat?: number;
  lng?: number;
  desc?: string;
  sub_device_index?: number;
  user_id?: string;
  user_name?: string;
  operator_id?: string;
  operator_name?: string;
  process_desc?: string;
  process_time?: number;
}
